var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-10 text-center"},[_c('h1',{staticClass:"text-3xl font-light"},[_vm._v(_vm._s(_vm.$t('pages.error_4xx.title'))+" "+_vm._s(_vm.statusCode)+" : "+_vm._s(_vm.$t('pages.error_4xx.status.'+_vm.statusCode)))])])}
var staticRenderFns = []

export { render, staticRenderFns }